import { AfterViewInit, Directive, ElementRef, inject, OnDestroy } from '@angular/core';

@Directive({
  selector: '[opacFocusTrap]'
})
export class FocusTrapDirective implements OnDestroy, AfterViewInit {
  private readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef);
  private element: HTMLElement;
  private handlerTabKeydown = this.handleTabKeydown.bind(this);

  ngAfterViewInit() {
    this.element = this.elementRef.nativeElement;
    document.addEventListener('keydown', this.handlerTabKeydown);
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.handlerTabKeydown);
  }

  private getActiveElement(): Element {
    if (document.activeElement?.shadowRoot) {
      return document.activeElement.shadowRoot.activeElement;
    }

    return document.activeElement;
  }

  private handleTabKeydown(event: KeyboardEvent) {
    const isTabPressed = event.key === 'Tab';

    if (!isTabPressed) {
      return;
    }

    const focusableElements = this.element.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    const firstFocusableElement = focusableElements[0] as HTMLElement;
    const lastFocusableElement = focusableElements[focusableElements.length - 1] as HTMLElement;

    if (event.shiftKey) {
      if (this.getActiveElement() === firstFocusableElement) {
        lastFocusableElement.focus?.();
        event.preventDefault();
      }
    } else {
      if (this.getActiveElement() === lastFocusableElement) {
        firstFocusableElement.focus?.();
        event.preventDefault();
      }
    }
  }
}
